import { heroData } from '@/mocks/home';

export default function HeroSection() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20warm%20atmosphere%20with%20soft%20gradated%20red%20and%20gold%20light%20rays%20across%20dark%20background%2C%20elegant%20film%20texture%2C%20theater%20curtain%20suggestion%2C%20no%20text%2C%20rich%20warm%20tones&width=1600&height=900&seq=hero-bg-51cinema&orientation=landscape"
          alt="51影院 - 全网影视资源免费在线观看"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="text-accent-400 text-sm md:text-base tracking-wider mb-3 font-medium">
              {heroData.tag}
            </p>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl leading-tight text-white mb-4 tracking-wide">
              {heroData.h1}
            </h1>

            <p className="text-base md:text-lg text-accent-300 mb-6 font-medium">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-background-200 leading-relaxed mb-8 max-w-2xl mx-auto lg:mx-0">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-400 font-heading">
                    {stat.value}
                  </div>
                  <div className="text-xs text-background-300 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.ctaPrimary.href}
                onClick={(e) => handleClick(e, heroData.ctaPrimary.href)}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-200 text-sm cursor-pointer no-underline text-center"
              >
                {heroData.ctaPrimary.label}
              </a>
              <a
                href={heroData.ctaSecondary.href}
                onClick={(e) => handleClick(e, heroData.ctaSecondary.href)}
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3 bg-white/15 hover:bg-white/25 text-white font-medium rounded-full transition-all duration-200 text-sm cursor-pointer no-underline text-center backdrop-blur-sm"
              >
                {heroData.ctaSecondary.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20cinema%20interior%20with%20warm%20red%20velvet%20theater%20seats%20and%20glowing%20golden%20screen%2C%20elegant%20art%20deco%20details%2C%20rich%20warm%20lighting%2C%20no%20people%2C%20luxurious%20atmosphere&width=1000&height=750&seq=hero-visual-cinema&orientation=landscape"
                alt="51影院高清影视体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}